import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator'
import { namespace } from 'vuex-class';
import { PROFILE_MODULE_NAMESPACE, PROFILE_SET_TICKET_REASON, PROFILE_SET_TICKET_SUBSTATUS } from '../../../../store/profile/profile-types.store';

const ProfileStore = namespace(PROFILE_MODULE_NAMESPACE)

@Component({})
export default class ClosingReasonsModalVertical extends Vue {

  @ProfileStore.Getter ticketReason: { name: string }
  @ProfileStore.Mutation(PROFILE_SET_TICKET_REASON)
  storeSetTicketReason: (payload: {id?:number, name?:string, disabled?:boolean}) => void;


  @Prop({default: false, type: [Boolean]})
  isUpdate: boolean


  dtRules: {}
  /* name:string
  description:string */
  constructor () {
    super()
    this.dtRules = {}
    /* this.name = ''
    this.description = '' */
  }

  get name():string {
    return this.ticketReason.name
  }

  set name(val:string) {
    this.storeSetTicketReason({name:val})
  }


  beforeMount()
  {
    this.dtRules = {
      nameRules: [ v => !!v || this.$t(this.lblSetting.emptyRequired, {type: this.$t(this.lblSetting.ticketReasonName)})]
    }
  }

  mounted(){

  }

  get lblSetting() {
    return {
      ...require('@/locales/profile').default,
      ...require('@/locales/validation-messages').default
    }
  }

  get textConfigs() {
    return require('@/assets/json-resources/text-field-configs.json')
  }
}



// WEBPACK FOOTER //
// ./src/containers/profile/components/ticket-reason-modal-vertical/index.ts